import keyBy from 'lodash/keyBy';

export default function remove(
    action: RemoveAreaAction,
    setAreas: React.Dispatch<React.SetStateAction<{[areaLocalId: string]: Area}>>
) {
    const data = (Array.isArray(action.data) ? action.data : [action.data]).map((area) => ({
        ...area,
        properties: {...area.properties, archived: true},
    }));

    setAreas((latestAreas) => ({
        ...latestAreas,
        ...keyBy(data, (area) => area.properties.localId),
    }));

    return data.map((area) => area.properties.localId);
}
